<div class="test-case-wrapper d-flex flex-column h-100">
  <mat-expansion-panel (opened)="onPanelExpand()" [expanded]="isExpanded">
    <mat-expansion-panel-header>
      <!-- <mat-panel-title> -->
      <span class="panel-header">{{ panelHeader }}</span>
      <!-- </mat-panel-title> -->
    </mat-expansion-panel-header>

    <div class="d-flex flex-row">
      <div
        class="col-md-3 side-panel"
        [ngClass]="{ disableItems: isAppContextProgress }"
      >
        <div
          [ngClass]="{ 'disable-cursor': isAppContextProgress }"
          class="d-flex flex-row align-items-center justify-content-start steps-div"
          *ngFor="let step of steps; let i = index"
          (click)="onStepClick(i)"
          (keydown)="onStepClick(i)"
        >
          <span
            class="accello-header4 step-font"
            [ngClass]="{ active: selectedIndex === i }"
            >{{ step.title }}</span
          >
        </div>
      </div>

      <div class="w-100">
        @if(selectedIndex === 1){ @if(isLoading) {
        <div style="width: 100%; height: 100%">
          <app-loading></app-loading>
        </div>
        } @else if(!isAppContextProgress) {
        <div
          class="d-flex flex-column pt-4 pb-4 align-items-start w-100 p-4 h-100"
        >
          <div
            class="file-upload-wrapper w-100"
            [ngClass]="{
              disableItems: uploadedApplicationContext?.originalFileName
            }"
          >
            <div
              class="d-flex flex-column w-100"
              [ngClass]="{
                'disable-cursor': uploadedApplicationContext?.originalFileName
              }"
            >
              <app-file-upload
                [data]="fileUploadConfig"
                (filesSelected)="handleFilesSelected($event)"
              ></app-file-upload>
            </div>
          </div>

          <div class="mb-2 mr-1 d-flex flex-grow-1 w-100 file-div">
            <div
              *ngIf="uploadedApplicationContext?.originalFileName"
              class="d-flex h-25 mt-4 file-content-wrapper"
            >
              <div class="d-flex flex-row align-items-center">
                <img
                  [src]="
                    getImagePath(uploadedApplicationContext?.originalFileName) | assetUrl
                  "
                  width="20px"
                  height="20px"
                  alt="Excel"
                  class="excel"
                />
                <div class="file-name-div">
                  <span class="accello-general-text12"
                    >{{
                      decodeFileName(
                        uploadedApplicationContext?.originalFileName
                      )
                    }}
                  </span>
                </div>
              </div>
              <div class="m-auto">
                <img
                  [src]="'images/virtusa-icons/delete.svg' | assetUrl"
                  alt="Excel"
                  class="remove-file"
                  (click)="deleteApplicationContext(uploadedApplicationContext)"
                  (keydown)="deleteApplicationContext(uploadedApplicationContext)"
                />
              </div>
            </div>
          </div>

          <div class="d-flex flex-row justify-content-end w-100">
            <button
              class="btn-accello-primary-light btn-accello mx-2"
              type="submit"
              [disabled]="selectedFile === null"
              (click)="uploadAppContext()"
            >
              Upload Application Context
            </button>
          </div>
        </div>
        } @else {
        <div class="v-center h-100 w-75 mx-auto">
          <app-progress-bar
            [text]="appContextProgressText"
            [progress]="progressPrecentage"
            [isError]="isProgressError"
          ></app-progress-bar>
        </div>
        } } @else{
        <div class="w-100 p-4 h-100">
          <span class="general-text-5">Extract User Stories From</span>
          <div class="radio-card-group d-flex justify-content-between">
            <label
              class="radio-card"
              *ngFor="let option of userStoryExtractOptions"
              [ngClass]="{ active: selectedStoryOption === option.value }"
            >
              <input
                type="radio"
                name="selection"
                [value]="option.value"
                [(ngModel)]="selectedStoryOption"
                (change)="onRadioSelect(option.value)"
              />
              <div class="radio-content">
                <div class="radio-title general-text-5">{{ option.title }}</div>
                <div class="accello-general-text9">
                  {{ option.description }}
                </div>
              </div>
            </label>
          </div>

          <div class="w-100 data-div">
            <div
              class="w-100 h-100 pt-4 pb-4 d-flex flex-column justify-content-between"
            >
              @if(selectedStoryOption === 'alm'){
              <app-dynamic-form
                [form]="dynamicForm"
                [formFields]="almFields"
                (modelChange)="onSelectProvider($event)"
              ></app-dynamic-form>
              } @else if(selectedStoryOption === 'doc'){
              <div class="w-100 d-flex flex-row justify-content-between">
                <div class="col-md-6">
                  <app-file-upload
                    class="mb-2"
                    [data]="userStoryFileConfig"
                    (filesSelected)="handleUserStoryFilesSelected($event)"
                  ></app-file-upload>
                </div>
                <div class="vertical-divider mx-3"></div>
                <div class="col-md-5">
                  <div class="rec-div">
                    <span class="header-11">Recommended</span>
                  </div>
                  <span class="general-text-16 rec-description">
                    You can download the attched template and use them as a
                    starting point for your own file.
                  </span>

                  <div
                    class="sample-file d-flex flex-row justify-content-between align-items-center"
                    *ngFor="let file of sampleFiles"
                  >
                    <div>
                      <img
                        [src]="file.icon"
                        [alt]="file.type"
                        class="pdf"
                        width="20px"
                        height="20px"
                      />
                      <span class="accello-general-text12 content-wrapper">{{
                        file.name
                      }}</span>
                    </div>
                    <div>
                      <!-- <img
                        [src]="'images/virtusa-icons/download-icon.svg' | assetUrl"
                        alt="Download"
                        class="pdf-download"
                        (click)="downloadTemplate(file.type)"
                      /> -->
                      <ng-container *ngIf="!file.loading; else loadingTpl">
                        <img
                          [src]="'images/virtusa-icons/download-icon.svg' | assetUrl"
                          alt="Download"
                          class="pdf-download"
                          (click)="downloadTemplate(file.type)"
                          (keydown.enter)="downloadTemplate(file.type)"
                        />
                      </ng-container>
                      <ng-template #loadingTpl>
                        <div
                          class="spinner-border text-primary"
                          style="width: 20px; height: 20px"
                        >
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              } @else if(selectedStoryOption=== 'storage'){
              <app-dynamic-form
                [form]="storageForm"
                [formFields]="storageFields"
                (modelChange)="onSelectProvider($event)"
              ></app-dynamic-form>
              }
              <div class="d-flex flex-row justify-content-end w-100">
                <button
                  class="btn-accello-primary-light btn-accello mx-2"
                  type="submit"
                  [disabled]="isExtractDisabled"
                  (click)="extractStories()"
                >
                  Extract User Stories
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </mat-expansion-panel>

  @if(isUserStoryExtracting){
  <div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <!-- <app-loading [text]="'Loading data'"></app-loading> -->
    <div class="w-50">
      <app-progress-bar
        [progress]="progressStatus.percentage"
        [text]="progressStatus.text"
        [isError]="progressStatus.isError"
      ></app-progress-bar>
    </div>
  </div>
  } @else {

  <div
    *ngIf="tableConfigs.rows?.length > 0"
    class="d-flex align-items-center mb-3 pt-2 mt-3 justify-content-between flex-row"
  >
    <div class="w-50 d-flex">
      <span class="flex-grow-1 general-text-2">
        User Story Count : ({{ selectedRowsCount }})
      </span>

      <div class="filter-select d-flex">
        <span> Status: </span>
        <select
          [(ngModel)]="selectedStatus"
          (change)="onStatusChange($event)"
        >
          <option value="">All</option>
          <option *ngFor="let opt of statusList" [value]="opt">
            {{ opt }}
          </option>
        </select>
      </div>
    </div>

    <div class="d-flex -flex-row align-items-center justify-content-end mx-2">
      <button
        class="btn-accello-primary-light btn-accello"
        type="button"
        [disabled]="!selectedRowsCount"
        (click)="generateKG()"
      >
        <span>
          <img src="assets/images/virtusa-icons/settings-light.svg" alt="add" />
        </span>
        View Knowledge Graph
      </button>

      <button
        class="btn-accello-ternary btn-accello mx-2"
        type="submit"
        [hidden]="true"
        (click)="removeUserStory()"
      >
        <span>
          <img src="assets/images/virtusa-icons/remove.png" alt="remove" />
        </span>
        Remove User Story
      </button>
    </div>
  </div>
  <div
    class="table-wrapper d-flex flex-grow-1 t-2"
    *ngIf="tableConfigs.rows?.length > 0"
  >
    @if(isFiltering) {
      <div class="text-center m-auto">
        <app-loading [text]="'Loading data..'"></app-loading>
      </div>
    }@else {
    <app-test-case-table
      class="w-100"
      [configs]="tableConfigs"
      [meta]="tableMeta"
      [zorroOptions]="zorroOptions"
      (onRowSelect)="handleRowSelection($event)"
      (handleActions)="handleActions($event)"
      (pageChange)="onPageChange($event)"
    >
    </app-test-case-table>
    }
  </div>
  }
</div>
